<template>
	<fs1-div>
		<v-data-table
			hide-default-footer
			hide-default-header
			disable-pagination
			:headers="headers"
			:items="rows"
			class="tablaT1 tableALTH1"
			:class="dark_t?'dark':''">
      <template v-slot:header>
				<thead>
				<tr>
					<th v-for="(th,i) in headers" :key="i" :colspan="th.colspan || 1">
						<div>
						<span>{{th.text}}</span>
						<fs1-tooltip v-if="th.tooltip">{{th.tooltip}}</fs1-tooltip>
						</div>
					</th>
				</tr>
				</thead>
      </template>
			<template v-slot:item="props">
				<tr>
					<td :rowspan="props.item.rowspan" v-if="props.item.rowspan"><fs1-span>{{ props.item.pwo_type }}</fs1-span></td>
					<td style="text-align:left !important;padding-left: 15px;"><fs1-span>{{ props.item.organization }}</fs1-span></td>

					<td style="color:black" @click="openModalTable(props.item,'previous_fy','ReportTable')" :class="getColor(props.item,'previous_fy')"><fs1-span>{{ props.item.previous_fy }}</fs1-span></td>
					<!-- <td style="color:black" @click="openModalTable(props.item,'previous_12mm_a')" :class="getColor(props.item,'previous_12mm_a')"><fs1-span>{{ props.item.previous_12mm_a }}</fs1-span></td>
					<td style="color:black" @click="openModalTable(props.item,'previous_3mm_a')" :class="getColor(props.item,'previous_3mm_a')"><fs1-span>{{ props.item.previous_3mm_a }}</fs1-span></td> -->
					<td style="color:black" @click="openModalTable(props.item,'current_fy','ReportTable')" :class="getColor(props.item,'current_fy')"><fs1-span>{{ props.item.current_fy }}</fs1-span></td>
					<td style="color:black" @click="openModalTable(props.item,'current_month','ReportTable')" :class="getColor(props.item,'current_month')"><fs1-span>{{ props.item.current_month }}</fs1-span></td>

					<td><fs1-span>{{ props.item.nro_work_orders }}</fs1-span></td>
					<!-- <td><fs1-span>{{ props.item.tendency }}</fs1-span></td> -->
					<td><fs1-span>{{ props.item.min_goal }}</fs1-span></td>

				</tr>
			</template>
			<template v-slot:no-data>
				<v-icon>warning</v-icon>
				Sin Información.
			</template>
		</v-data-table>

	</fs1-div>
</template>

<script>

export default {
  props:{
		openModalTable:{
			default:()=>()=>{}
		}
	},
  data() {
    return {

    };
  },
  computed: {
		dashboard_metrics_specific_headers(){ return this.$store.getters.dashboard_metrics_specific_headers },
    headers() {
			const hds = this.dashboard_metrics_specific_headers || {};
			
      return [
				{ text: 'Mant. Preventivo ASI', sortable: false,colspan:2},
				{ text: hds['previous_fiscal_year'] || '', sortable: false},
				/* { text: hds['12mm'] || '', sortable: false},
				{ text: hds['3mm'] || '', sortable: false}, */
				{ text: hds['current_fiscal_year'] || '', sortable: false},
				{ text: hds['current_month'] || '', sortable: false},
				{ text: hds['work_orders'] || '', sortable: false},
				/* { text: hds['tendency'] || '', sortable: false}, */
				{ text: hds['min_goal'] || '', sortable: false},
			];
    },
    rows() {
			const rows = this.$store.getters.dashboard_metrics_report_table;
			//considerar q bienen ordenados por pws_types
			rows.forEach((e,i) => {
				//primer elemento
				if (i === 0){
					e.rowspan = rows.filter(f => f.pwo_type === e.pwo_type).length;
					return
				}
				// si el anterior es != pwo_type
				if (rows[i-1].pwo_type !== e.pwo_type){
					e.rowspan = rows.filter(f => f.pwo_type === e.pwo_type).length;
					return;
				}
				
			});
			return rows;
		},

  },
  components:{  },
  methods: {
		getColor(item,key){
			const goal = item.min_goal.split(' ');
			const min_goal = parseFloat(goal[1]);
			const toCompare = parseFloat(item[key]);
			if('>' == goal[0]) return toCompare > min_goal?'bg-green':'bg-red';
			if('>=' == goal[0]) return toCompare >= min_goal?'bg-green':'bg-red';
			if('<' == goal[0]) return toCompare < min_goal?'bg-green':'bg-red';
			if('<=' == goal[0]) return toCompare <= min_goal?'bg-green':'bg-red';
			return '';
		}
  }, // methods
};
</script>
